export default __webpack_public_path__ + "static/media/jane.1f9bb33d.png";